import { MsDisabled as f, MsWarningCircle as p, MsArrowDown as g } from "@sunrise/icons";
import { defineComponent as V, ref as b, computed as l } from "vue";
const y = V({
  name: "CsDropdown",
  components: {
    MsArrowDown: g,
    MsWarningCircle: p,
    MsDisabled: f
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: String,
    options: Array,
    label: String,
    errorMsg: String,
    isDisabled: {
      type: Boolean,
      default: !1
    },
    noEmptyOption: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = b(!1), r = l(() => !!e.errorMsg), s = l(() => e.modelValue), u = l(() => {
      var n;
      const o = (n = e.options) == null ? void 0 : n.find((c) => c.value === e.modelValue);
      return o ? o.label : "";
    });
    function i() {
      t.value = !0;
    }
    function d() {
      t.value = !1;
    }
    function m(o) {
      const n = o.target;
      a("update:modelValue", n.value);
    }
    return {
      currentLabel: u,
      onChange: m,
      isFilled: s,
      hasFocus: t,
      onFocus: i,
      onBlur: d,
      hasError: r
    };
  }
});
export {
  y as default
};
